"use client";

import { LanguageOption, LanguageSelector } from "@jesus-central-church/ui";
import { usePathname, useRouter } from "next/navigation";
import { useCallback } from "react";
import { availableLanguages } from "../../config/availableLanguages";

const LANGUAGE_OPTIONS: LanguageOption[] = [
  { code: "nl", label: "Nederlands", flag: "🇳🇱" },
  { code: "en", label: "English", flag: "🇬🇧" },
];

interface FooterLanguageSelectorProperties {
  currentLocale: string;
}

export function FooterLanguageSelector({
  currentLocale,
}: FooterLanguageSelectorProperties) {
  const router = useRouter();
  const pathname = usePathname();

  const handleLanguageChange = useCallback(
    (newLocale: string) => {
      // Set cookie to remember language preference

      // Parse current path to determine the new path
      const pathSegments = pathname.split("/").filter(Boolean);

      // Check if current path has a language prefix
      const hasLanguagePrefix = availableLanguages.includes(pathSegments[0]);

      let newPath: string;

      if (newLocale === "nl") {
        // Dutch is default, no prefix needed
        if (hasLanguagePrefix) {
          // Remove the language prefix
          pathSegments.shift();
        }
        newPath = pathSegments.length > 0 ? `/${pathSegments.join("/")}` : "/";
      } else {
        // Other languages need prefix
        if (hasLanguagePrefix) {
          // Replace existing language prefix
          pathSegments[0] = newLocale;
        } else {
          // Add language prefix
          pathSegments.unshift(newLocale);
        }
        newPath = `/${pathSegments.join("/")}`;
      }

      const newUrl = new URL(newPath, globalThis.location.origin);
      globalThis.location.href = newUrl.toString();
    },
    [pathname, router],
  );

  return (
    <LanguageSelector
      languages={LANGUAGE_OPTIONS}
      selectedLanguage={currentLocale}
      onLanguageChange={handleLanguageChange}
    />
  );
}
